import React from 'react';
import { FaUserAlt } from "react-icons/fa";
import { RiMoneyEuroCircleFill } from "react-icons/ri";
import dayjs from 'dayjs';


const OpenGuests = ({ guests, expandedGuest, onToggleGames, onPaymentClick, onGameClick }) => {
    
    return (
        <div className='bg-white rounded px-3 pb-3 pt-3 shadow'>
            <div className='text-center fs-5 fw-semibold text-danger'>Offene Gastgebühren</div>
            <div className='row my-2 align-items-center py-2 text-center'>
                <div className='col-6 col-md-5 infotext'><FaUserAlt size={22} /></div>
                <div className='col-3 col-md-4 infotext'><RiMoneyEuroCircleFill size={22} /></div>
                <div className='col-3 col-md-3 infotext'></div>
            </div>
            {guests.map((guest, index) => (
                <div key={index} className='row my-2 align-items-center border-bottom py-3 text-center'>
                    <div 
                        className={`col-6 col-md-5 fs-7 ${expandedGuest === guest.id && 'fw-semibold'}`} 
                        onClick={() => onToggleGames(guest.id)} 
                        style={{ cursor: 'pointer' }}
                    >
                        {guest.name}
                    </div>
                    <div className='col-3 col-md-4 fs-7 d-flex align-items-center justify-content-center gap-1'>
                        {guest.amount}
                    </div>
                    <div className='col-3 col-md-3 infotext text-danger' onClick={() => onPaymentClick(guest)} style={{ cursor: 'pointer' }}>
                        <RiMoneyEuroCircleFill size={24} />
                    </div>


                    {expandedGuest === guest.id && (
                        <div className='col-12 mt-2'>
                            {guest.games.map((game, gameIndex) => (
                                <div 
                                    key={gameIndex} 
                                    className={`row my-1 align-items-center py-2 text-center shadow-sm rounded-5 booking mx-0 interactive-row ${game.guestPlayerpayed ? 'paid' : 'bg-white'}`}
                                    onClick={() => onGameClick && onGameClick(game.id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className='col-3 col-md-3 fs-7'>{dayjs(game.date).format("DD.MM.YYYY")}</div>
                                    <div className='col-3 col-md-3 fs-7'>{game.type === "single" ? "Einzel" : "Doppel"}</div>
                                    <div className='col-2 col-md-2 fs-7'>{game.hours} h</div>
                                    <div className='col-2 col-md-2 fs-7'>{game.guestcount} {game.guestcount > 1 ? "Gäste" : "Gast"}</div>
                                    <div className='col-2 col-md-2 fs-7'>{game.rate} €</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default OpenGuests;
